import React from 'react'
import PropTypes from 'prop-types'
import { StatisticsFeedbackItems } from '../../organism'
import { MODULES } from '../../../config/constants'

const Statistics = ({ classes }) => (
  <div className={classes.root}>
    <StatisticsFeedbackItems module={MODULES.ID_FEEDBACK} />
  </div>
)

Statistics.propTypes = {
  classes: PropTypes.object.isRequired
}

export default Statistics
